import React, { useState, useEffect } from "react";
import useApi from "../../Hooks/useApi";
import * as api from "../../api/getapi";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import Loader from "../Loader";

const CreateOrderRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const url = location.pathname;
  const id = url.split("-").pop();
  const fetchOrderListing = useApi(api.fetchOrderListing, { hasCatchError: true });
  const [listingData, setlistingData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  function getOrderListing() {
    fetchOrderListing
      .request(id)
      .then((data) => {
        setError("");
        setIsLoading(false);
        setlistingData(data.data.data);
        if (data.data.data.listing.listed_quantity === 0) {
          setIsLoading(false);
          setError("This listing is not available for order");
        } else if (data.data.data.listing.listed_quantity > 0) {
          navigate(`/delivery-for-you/orders/create`, {
            state: {
              listingData: data.data.data,
            },
          });
        }
      })
      .catch((err) => {
        setError("You are looking for Invalid Listing OR this listing is no longer available");
        setlistingData(null);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    let timeout;
    setIsLoading(true);
    getOrderListing();
    return () => {
      clearTimeout(timeout);
    };
  }, [id]);
  return (
    <>
      {isLoading ? (
        <div
          style={{
            height: "50vh",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Loader />
        </div>
      ) : error ? (
        <div className="alert alert-warning border-dotted" style={{ border: "2px" }}>
          <div className="d-flex justify-content-center align-items-center font-weight-bold fs-4">*{error}</div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default CreateOrderRedirect;
